import { render, staticRenderFns } from "./PurchasingClosed.vue?vue&type=template&id=40c907eb&"
import script from "./PurchasingClosed.vue?vue&type=script&lang=js&"
export * from "./PurchasingClosed.vue?vue&type=script&lang=js&"
import style0 from "./PurchasingClosed.vue?vue&type=style&index=0&id=40c907eb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports